<template>
	<div class='story'>
		<div class="knd-header">
			<div class="header-animatie" ref='animation'>
					<lottie-player 
						class="header-gif"
						:src="require('@/assets/animation/header/vreetparadijs.json')" 
						background="transparent"  
						speed="1"  
						style="width: 100%; height: 100%;" 
						loop 
						autoplay>
					</lottie-player>

			</div>
			<div class="header-titel">
				<h1 class='article-hero__title'>{{ content.kop.tekst }}</h1>
				<p>{{ content.kop.onderkop }}</p>
				<Pijl :kleur="'#fff'" />
			</div>
		</div>

		<VideoScroll 
			desktopUrl="Tijdmachine_1_desktop_420.mp4" 
			mobielUrl="Tijdmachine_1_mobiel_420.mp4" 
			:content="content.scrolly_1" 
		/>

		<SetLocation />
		
		<MapStory :content="getMapContent()" />

		<VideoStory :videoUrl="require('@/assets/Interview_Eva_LQ.mp4')" :content="getVideoContent()" />

		<GrafiekKaart :content="content.scrolly_4"  />

		<VideoScroll 
			desktopUrl="Tijdmachine_2_desktop_420.mp4" 
			mobielUrl="Tijdmachine_1_mobiel_420.mp4" 			
			:content="content.scrolly_5" 
		/>

		<div class="call-to-action">
			<div class="call-to-action__content">
				<p class="kop">{{ content.call_to_action.kop }}</p>
				<p v-html="content.call_to_action.tekst_1"></p>
				<div class="artikel-link" @click='gotoLink(content.call_to_action.url_1)'>
					<div class="link-image">
						<img :src='require("@/assets/thumb_dataverantwoording.jpg")' />
					</div>
					<p>Dataverantwoording: een veranderende eetomgeving</p>
				</div>
				<p v-html="content.call_to_action.tekst_2"></p>
				<div class="artikel-link" @click='gotoLink(content.call_to_action.url_2)'>
					<div class="link-image">
						<img :src='require("@/assets/thumb_vet.jpg")' />
					</div>
					<p>Vet!</p>
				</div>
				<p v-html="content.call_to_action.tekst_3"></p>
			</div>
		</div>

		<div class="colofon">
				<p class="kop">Colofon</p>
				<p v-html="content.colofon.tekst"></p>
		</div>
	</div>
</template>

<script>
import MapStory from './map-story';
import VideoStory from './video-story';
import GrafiekKaart from './grafiek-kaart/';
import VideoScroll from './video-scroll/';
import Pijl from './pijl';

import SetLocation from './set-location/';

import LottiePlayer from "@lottiefiles/lottie-player";

export default {
	name: 'Story',
	mounted: function() {
		let gemeenten = this.$store.state.gemeentenAutocomplete;
		const gemeente = gemeenten.find((d) => {
			return d.code === "GM0402"; //Hilversum
		});
		
		this.$store.dispatch('loadGemeente', gemeente); 
	},
	data() {
		return {
			content: this.$store.state.content
		}
	},
	components: {
		MapStory,
		VideoStory,
		GrafiekKaart,
		VideoScroll,
		Pijl,
		SetLocation,
		LottiePlayer
	},
	computed: {
		buurtSelected() {
			return this.$store.getters.buurtSelected;
		},

		buurtScenario() {
			return this.$store.getters.buurtScenario;
		}
	},
	methods: {
		getMapContent() {
			if (this.buurtScenario === "stijging") {
				return this.content.scrolly_2_1;
			}
			else if (this.buurtScenario === "daling") {
				return this.content.scrolly_2_0;
			}
			else if (this.buurtScenario === "geen") {
				return this.content.scrolly_2_0;
			}
			return this.content.scrolly_2_1;
		},

		getVideoContent() {
			if (this.buurtSelected && this.buurtSelected.buurt_ongezond_2021 > 0 || this.buurtSelected && this.buurtSelected.buurt_ongezond_2011 > 0) {
				return this.content.scrolly_3;
			}
			else if (this.buurtSelected) {
				return this.content.scrolly_3_0;
			}
		},

		gotoLink(url) {
			window.open(url);
		}
	}
}
</script>